import i18n from "@/common/i18n";
/***
 * 隐私协议相关配置
 */
import { nanoid } from 'nanoid';
export default {
  reporType: 100181,
  //中文
  zh: {
    contentPlaceholder: `${i18n.t("lang.k_374001")}`,
    contentValue: `${i18n.t("lang.k_374001")}`,
    colorTextPlaceholder: `${i18n.t("lang.k_374002")}`,
    colorTextValue: `${i18n.t("lang.k_374003")}`,
    urlPlaceholder: `${i18n.t("lang.k_374004")}`
  },
  // 英文
  en: {
    contentPlaceholder: 'We protect all the information you provide according to our 《Privacy Statement》',
    contentValue: 'We protect all the information you provide according to our 《Privacy Statement》',
    colorTextPlaceholder: `${i18n.t("lang.k_374002")}`,
    colorTextValue: '《Privacy Statement》',
    urlPlaceholder: `${i18n.t("lang.k_374004")}`
  },
  // 创建一个隐私协议项
  create(lang = 'zh') {
    return {
      label: `${i18n.t("lang.k_374005")}`,
      subject: `${i18n.t("lang.k_374005")}`,
      privacy: true,
      activeCollapse: '0',
      // 扩展属性， 隐私声明可以多个，使用折叠面板展示,该属性标识当前展开的折叠面板
      options: {
        show_checkbox: 1,
        list: [{
          id: nanoid(),
          is_must: 1,
          content: this[lang].contentValue,
          options: [{
            color_text: this[lang].colorTextValue,
            url: ''
          }]
        }]
      },
      items: [],
      reporType: this.reporType,
      reqType: 6,
      default_type: 6,
      system_type: 6
    };
  }
};